// Утилита для обработки сетевых ошибок
export const isNetworkError = (error) => {
  if (!error) return false;

  // Проверяем различные типы сетевых ошибок
  const networkErrorCodes = [
    'NETWORK_ERROR',
    'ERR_NETWORK',
    'ERR_INTERNET_DISCONNECTED',
    'ERR_NETWORK_CHANGED',
    'ERR_CONNECTION_REFUSED',
    'ERR_CONNECTION_TIMED_OUT',
    'ERR_NAME_NOT_RESOLVED',
    'ERR_CONNECTION_RESET',
    'ERR_CONNECTION_ABORTED',
  ];

  const networkErrorMessages = [
    'Network Error',
    'Network request failed',
    'Failed to fetch',
    'Connection refused',
    'Connection timed out',
    'Name resolution failed',
    'No internet connection',
  ];

  // Проверяем код ошибки
  if (error.code && networkErrorCodes.includes(error.code)) {
    return true;
  }

  // Проверяем сообщение об ошибке
  if (
    error.message &&
    networkErrorMessages.some((msg) => error.message.toLowerCase().includes(msg.toLowerCase()))
  ) {
    return true;
  }

  // Проверяем статус ответа (если есть)
  if (error.response && error.response.status === 0) {
    return true;
  }

  // Проверяем состояние интернета
  if (typeof navigator !== 'undefined' && !navigator.onLine) {
    return true;
  }

  return false;
};

// Функция для безопасной обработки сетевых ошибок
export const handleNetworkError = (error, silent = true) => {
  if (isNetworkError(error)) {
    if (!silent) {
      // console.warn('Network error detected, ignoring:', error.message);
    }
    return true; // Ошибка обработана
  }

  return false; // Ошибка не является сетевой
};

export default { isNetworkError, handleNetworkError };
